import React from 'react';
import { Routes, Route } from 'react-router-dom';
import PrincipalDashboard from '../components/PrincipalDashboard';
import ManageFees from '../components/ManageFees';
import FeeAccountTabs from '../components/FeeAccountTabs';
import StaffProfile from '../components/StaffProfile';
import Settings from '../components/Settings';

// Staff Modules (for principal access)
import Attendance from './staff/Attendance';
import Assessment from './staff/Assessment';
import Clinical from './staff/Clinical';
import LessonPlan from './staff/LessonPlan';
import Library from './staff/Library';
import Notices from './staff/Notices';
import Reports from './staff/Reports';
import Rotation from './staff/Rotation';

// PDF helper: auto-selects voucher vs receipt
import ReceiptDownload from '../components/ReceiptDownload';

function PrincipalPage({ user, token, onLogout }) {
  // convenience wrapper to pass to children
  const handleGeneratePDF = async (row, opts = {}) => {
    // generateAuto will choose voucher for refunds, receipt otherwise
    return ReceiptDownload.generateAuto(row, opts);
  };

  return (
    <div className="principal-page">
      <Routes>
        {/* Principal Dashboard */}
        <Route path="/" element={<PrincipalDashboard user={user} token={token} />} />

        {/* Principal-only fee management
            - pass principalMode so ManageFees can alter behavior (show Voucher button, etc.)
            - pass handleGeneratePDF so child can call generateAuto and get the same output as admin
        */}
        <Route
          path="manage-fees"
          element={
            <ManageFees
              user={user}
              token={token}
              principalMode={true}
              onGeneratePDF={handleGeneratePDF}
            />
          }
        />
        <Route
          path="manage-fees/:studentId"
          element={
            <FeeAccountTabs
              user={user}
              token={token}
              principalMode={true}
              onGeneratePDF={handleGeneratePDF}
            />
          }
        />

        {/* Profile and settings */}
        <Route path="profile" element={<StaffProfile user={user} token={token} />} />
        <Route path="settings" element={<Settings user={user} token={token} onLogout={onLogout} />} />

        {/* Staff modules, available to principal */}
        <Route path="attendance" element={<Attendance user={user} token={token} />} />
        <Route path="assessment" element={<Assessment user={user} token={token} />} />
        <Route path="clinical" element={<Clinical user={user} token={token} />} />
        <Route path="lessonplan" element={<LessonPlan user={user} token={token} />} />
        <Route path="library" element={<Library user={user} token={token} />} />
        <Route path="notices" element={<Notices user={user} token={token} />} />
        <Route path="reports" element={<Reports user={user} token={token} />} />
        <Route path="rotation" element={<Rotation user={user} token={token} />} />
      </Routes>
    </div>
  );
}

export default PrincipalPage;